export const MAX_FILESIZE = 100 * 1024 * 1024;

// The write signed URL signs this Content-Type. The browser upload must send it.
const UPLOAD_CONTENT_TYPE_BY_EXTENSION = {
  csv: "text/csv",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  gif: "image/gif",
  html: "text/html",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  md: "text/markdown",
  pdf: "application/pdf",
  png: "image/png",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  txt: "text/plain",
  webp: "image/webp",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
} as const;

export const ALLOWED_UPLOAD_EXTENSIONS = Object.keys(
  UPLOAD_CONTENT_TYPE_BY_EXTENSION,
).map((extension) => `.${extension}`);

export const uploadExtension = (name: string): string | null => {
  if (name.includes("\0")) {
    return null;
  }

  const lastDot = name.lastIndexOf(".");
  if (lastDot <= 0) {
    return null;
  }

  return name.slice(lastDot + 1).toLowerCase();
};

export const contentTypeForUploadName = (name: string): string | null => {
  const extension = uploadExtension(name);
  if (!extension) {
    return null;
  }

  return (
    UPLOAD_CONTENT_TYPE_BY_EXTENSION[
      extension as keyof typeof UPLOAD_CONTENT_TYPE_BY_EXTENSION
    ] ?? null
  );
};
